import React, { useState, useEffect, useRef } from 'react'
import { IoAddCircleOutline, IoRemoveCircleOutline, IoChevronForwardOutline, IoCalendarOutline, IoPersonOutline, IoFileTrayStackedOutline } from "react-icons/io5";
import AdmissionModal from '../AdmissionModal/AdmissionModal'
import AdmissionImage1 from "../../../assets/admissionimages/admission1.jpeg"
import AdmissionImage2 from "../../../assets/admissionimages/admission2.jpeg"
import AdmissionImage3 from "../../../assets/admissionimages/admission3.jpeg"

const AdmissionSection = () => {
    const [admissionModal, setAdmissionModal] = useState(false)
    const [openTab, setOpenTab] = useState(false)
    const [slideIndex, setSlideIndex] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true)
    const timeOut = useRef(null);

    const images = [AdmissionImage1, AdmissionImage2, AdmissionImage3];

    useEffect(() => {
        if(admissionModal){
            document.body.style.overflow = 'hidden'
        }else{
            document.body.style.overflow = 'scroll'
        }
        
        if (autoPlay) {
            timeOut.current = setTimeout(() => {
                setSlideIndex(prev => (prev < images.length - 1 ? prev + 1 : 0));
            }, 3000);
        }

        return () => {
            if (timeOut.current) {
                clearTimeout(timeOut.current);
            }
        };
    }, [autoPlay, admissionModal, slideIndex, images.length]);

  return (
    <div className='main-container bg-white font-sans' id='admission-section'>
        {
            admissionModal && <AdmissionModal admissionModal={admissionModal} setAdmissionModal={setAdmissionModal}/>
        }

        {/* Hero Section */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 mb-16">
            <div className="flex-1 space-y-8 text-center lg:text-left">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#021D53] leading-tight tracking-tight">
                    Anell Admission <span className="text-primary">Policy</span>
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto lg:mx-0">
                    Discover our commitment to excellence and the clear pathway for your child to join our vibrant learning community.
                </p>
                {/* <div 
                    className="inline-flex items-center px-8 py-4 bg-[#021D53] text-white rounded-full font-semibold hover:bg-[#032770] transition-all transform hover:scale-105 cursor-pointer shadow-lg group"
                    onClick={() => setAdmissionModal(true)}
                >
                    Apply for Admission
                    <IoChevronForwardOutline className="ml-2 group-hover:translate-x-1 transition-transform" />
                </div> */}
            </div>

            <div className="flex-1 w-full max-w-2xl">
                <div 
                    className="relative aspect-[4/3] rounded-3xl overflow-hidden shadow-2xl group border-4 border-slate-50"
                    onMouseEnter={() => setAutoPlay(false)}
                    onMouseLeave={() => setAutoPlay(true)}
                >
                    {images.map((img, index) => (
                        <div 
                            key={index}
                            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === slideIndex ? 'opacity-100' : 'opacity-0'}`}
                        >
                            <img 
                                src={img} 
                                alt={`admission-${index + 1}`} 
                                className="w-full h-full object-cover transform transition-transform duration-[5s] group-hover:scale-110" 
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#021D53]/40 to-transparent" />
                        </div>
                    ))}
                    
                    {/* Slide Indicators */}
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setSlideIndex(index)}
                                className={`h-2 rounded-full transition-all duration-300 ${index === slideIndex ? 'w-8 bg-white' : 'w-2 bg-white/50'}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>

        {/* Requirements Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {/* Application Period */}
            <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-xl transition-shadow group">
                <div className="bg-white w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform">
                    <IoCalendarOutline className="text-3xl text-[#021D53]" />
                </div>
                <h3 className="text-xl font-bold text-[#021D53] mb-4 uppercase tracking-wide">Application Period</h3>
                <p className="text-gray-600 leading-relaxed text-justify">
                    Typically announced on our official website and social media (Instagram & Facebook). Parents are expected to submit applications during this designated time.
                </p>
            </div>

            {/* Age Requirement */}
            <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-xl transition-shadow group">
                <div className="bg-white w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform">
                    <IoPersonOutline className="text-3xl text-[#021D53]" />
                </div>
                <h3 className="text-xl font-bold text-[#021D53] mb-4 uppercase tracking-wide">Age & Grade Levels</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">Available grade levels include:</p>
                <div className="flex flex-wrap gap-2">
                    {['Babycare & Creche', 'Pre-K / Nursery', 'Reception / KG', 'Grade School'].map((grade) => (
                        <span key={grade} className="px-3 py-1 bg-[#021D53]/5 text-[#021D53] rounded-lg text-sm font-medium">
                            {grade}
                        </span>
                    ))}
                </div>
            </div>

            {/* Application Forms */}
            <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-xl transition-shadow group">
                <div className="bg-white w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform">
                    <IoFileTrayStackedOutline className="text-3xl text-[#021D53]" />
                </div>
                <h3 className="text-xl font-bold text-[#021D53] mb-4 uppercase tracking-wide">Application Forms</h3>
                <p className="text-gray-600 leading-relaxed text-justify">
                    Obtained online via our website or in hard copy at the administrative office. A non-refundable fee applies for processing.
                </p>
            </div>
        </div>

        {/* Admission Process / Supporting Documents */}
        <div className={`rounded-3xl border transition-all duration-500 overflow-hidden ${openTab ? 'bg-[#FBFCFF] border-[#5BA2F433] shadow-lg' : 'bg-[#021D53] border-[#021D53] shadow-md'}`}>
            <button 
                className="w-full flex items-center justify-between p-8 text-left focus:outline-none group"
                onClick={() => setOpenTab(!openTab)}
            >
                <h3 className={`text-xl font-bold transition-colors ${openTab ? 'text-[#021D53]' : 'text-white underline decoration-white/30'}`}>
                    {openTab ? 'SUPPORTING DOCUMENTS' : 'THE ADMISSION PROCESS'}
                </h3>
                {openTab ? 
                    <IoRemoveCircleOutline className="text-2xl text-[#021D53]" /> : 
                    <IoAddCircleOutline className="text-2xl text-white group-hover:scale-125 transition-transform" />
                }
            </button>

            <div className={`transition-all duration-500 ease-in-out ${openTab ? 'max-h-[2000px] opacity-100 p-8 pt-0' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                <div className="space-y-8">
                    <div className="bg-white/50 p-6 rounded-2xl border border-slate-100">
                        <p className="text-gray-700 font-medium mb-4">Required documents to submit with the application form:</p>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {[
                                "Child's original birth certificate (Photocopy)",
                                "Photocopy of the NHIS card",
                                "Last academic report (if transferring)",
                                "Passport-sized photos of the learner"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start">
                                    <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-3 flex-shrink-0" />
                                    <span className="text-gray-600 text-sm">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">01</span>
                                MANDATORY MEDICAL SCREENING
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Prospective learners are required to undergo a mandatory medical screening at Garden City Hospital which is the school’s approved medical center for all prospective applicants. This medical screening is the responsibility of the parent or guardian. A certificate of medical fitness from the hospital must be submitted as part of the application process.
                            </p>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">02</span>
                                INTERVIEW / ENTRANCE EXAM
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Anell School of Excellence may require applicants to participate in an interview or take an entrance examination. This requirement may vary depending on the grade level applied for. The school will communicate the details of such assessments if necessary.
                            </p>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">03</span>
                                ADMISSION CRITERIA
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Admission to Anell School of Excellence is determined by evaluating various factors, including:
                            </p>
                            <ul className='text-gray-600 text-sm text-justify leading-relaxed'>
                                <li>The child's age and compliance with age requirements.</li>
                                <li>Academic performance if applicable</li>
                                <li>Interview or examination results if required.</li>
                                <li>Availability of space in the desired grade level.</li>
                            </ul>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">04</span>
                                NOTIFICATION OF ACCEPTANCE
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Once the school has thoroughly reviewed all applications and conducted assessments, parents or guardians will be notified of the admission decision. This notification will be provided in the form of an official acceptance letter or email.
                            </p>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">05</span>
                                REGISTRATION
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Parents or guardians of accepted students will be required to complete the registration process. This process includes submitting any additional necessary documents and payment of the registration fees.
                            </p>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">06</span>
                                BILL ENQUIRIES
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                It is essential for parents or guardians to inquire about the school bill and its associated expenses during the application process. Anell School of Excellence will provide detailed information regarding tuition and fees to ensure transparency.
                            </p>
                        </div>
                        <div className="space-y-3">
                            <h4 className="text-lg font-bold text-[#021D53] flex items-center">
                                <span className="w-8 h-8 rounded-lg bg-[#021D53] text-white flex items-center justify-center text-xs mr-3">07</span>
                                ORIENTATION
                            </h4>
                            <p className="text-gray-600 text-sm text-justify leading-relaxed">
                                Anell School of Excellence organizes orientation programs for new students and their parents or guardians. These orientation sessions are designed to acquaint families with the school's policies, procedures, and facilities, ensuring a smooth transition into the school community.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AdmissionSection
